import { render } from "./DettaglioProgettoMenu.vue?vue&type=template&id=ead319e4&ts=true"
import script from "./DettaglioProgettoMenu.vue?vue&type=script&lang=ts"
export * from "./DettaglioProgettoMenu.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__